import React, { useContext, useState } from 'react';
import './styles.css';
import Button from '@mui/material/Button';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { UserContext } from '../../../providers/UserProvider';

const SalesCenterComplete = ({ salesCenter }) => {
  const userContext = useContext(UserContext);
  const [cloneStatus, setCloneStatus] = useState(null);
  const [cloneMessage, setCloneMessage] = useState('');
  const [cfStatus, setCfStatus] = useState(null);

  const hasCloneSource = !!(salesCenter.projectToClone);
  const cfFailed = salesCenter.jenkinsCloudFunctionDeployment
    && salesCenter.jenkinsCloudFunctionDeployment.status === 'ERROR';

  const triggerClone = () => {
    setCloneStatus('IN-PROGRESS');
    setCloneMessage('Cloning project data...');
    userContext.socket.emit(
      'cloneProject',
      {
        subdomainToCloneFrom: salesCenter.projectToClone,
        subdomainToCloneTo: salesCenter.subdomain,
        fullClone: salesCenter.fullClone || false,
      },
      (status) => {
        if (status === 'ERROR') {
          setCloneStatus('ERROR');
          setCloneMessage('Clone failed. Check server logs.');
        } else {
          setCloneStatus('COMPLETE');
          setCloneMessage('Clone complete');
        }
      },
    );
  };

  const triggerCloudFunctions = () => {
    setCfStatus('IN-PROGRESS');
    userContext.socket.emit(
      'deployFirebaseCloudFunctions',
      salesCenter.subdomain,
      (status) => {
        setCfStatus(status);
      },
    );
  };

  return (
    <div
      style={
{
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '330px',
  transform: 'translateY(10%)',
  gap: '20px',
}
}
    >
      <DoneAllIcon style={{ fontSize: '100px', color: 'lightseagreen' }} />
      <span>Setup Complete</span>

      {
        (hasCloneSource || cfFailed) && (
          <div
            style={
{
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '10px',
  padding: '20px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  minWidth: '350px',
}
}
          >
            {
              hasCloneSource && (
                <div
                  style={
{
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}
}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={triggerClone}
                    disabled={cloneStatus === 'IN-PROGRESS'}
                  >
                    {
cloneStatus === 'COMPLETE'
  ? 'Re-run Clone'
  : 'Trigger Clone'
}
                  </Button>
                  <span style={{ fontSize: '13px', color: '#666' }}>
                    from {salesCenter.projectToClone}
                  </span>
                  {
                    cloneStatus === 'IN-PROGRESS'
                    && <CircularProgress size={20} />
                  }
                  {
                    cloneStatus === 'COMPLETE'
                    && (
                      <CheckCircleIcon
                        style={{ color: 'green' }}
                      />
                    )
                  }
                  {
                    cloneStatus === 'ERROR'
                    && (
                      <ErrorIcon style={{ color: 'red' }} />
                    )
                  }
                  {
                    cloneMessage && (
                      <span style={{ fontSize: '12px' }}>
                        {cloneMessage}
                      </span>
                    )
                  }
                </div>
              )
            }

            {
              cfFailed && (
                <div
                  style={
{
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}
}
                >
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={triggerCloudFunctions}
                    disabled={cfStatus === 'IN-PROGRESS'}
                  >
                    Retry Cloud Functions
                  </Button>
                  {
                    cfStatus === 'IN-PROGRESS'
                    && <CircularProgress size={20} />
                  }
                  {
                    cfStatus === 'COMPLETE'
                    && (
                      <CheckCircleIcon
                        style={{ color: 'green' }}
                      />
                    )
                  }
                  {
                    cfStatus === 'ERROR'
                    && (
                      <ErrorIcon style={{ color: 'red' }} />
                    )
                  }
                </div>
              )
            }
          </div>
        )
      }
    </div>
  );
};

export default SalesCenterComplete;
